const portalExteriorPacienteInitialState = {
  portalPaciente: {
    loading: false,
    error: null,
    data: null,
  },
  portalExterior: {
    loading: false,
    error: null,
    data: null,
  },
};

export default portalExteriorPacienteInitialState;
